import { render, staticRenderFns } from "./Leden.vue?vue&type=template&id=551e3172&scoped=true&"
import script from "./Leden.vue?vue&type=script&lang=js&"
export * from "./Leden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e3172",
  null
  
)

export default component.exports